var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-layout app-layout-backend"},[_c('nav-bar'),_c('b-container',{attrs:{"fluid":""}},[_vm._t("default"),_c('footer-bar')],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }